"use client";
import type { RefObject } from "react";
import { useEffect } from "react";
import { useInstantSearch } from "react-instantsearch";

/**
 * Refining while the dialog is open can shrink the list below the current scroll offset.
 * The browser then clamps the scroll position and drags the sticky toolbar (and the dialog
 * inside it) out of the viewport, so we re-pin it to its sticky offset after every search.
 */
export const KeepFiltersDialogInView = ({
    toolbarRef,
}: {
    toolbarRef: RefObject<HTMLDivElement>;
}) => {
    const { results } = useInstantSearch();

    useEffect(() => {
        const toolbar = toolbarRef.current;

        if (!toolbar) return;

        const frameId = requestAnimationFrame(() => {
            const stickyTop = parseFloat(getComputedStyle(toolbar).top) || 0;
            const { top } = toolbar.getBoundingClientRect();

            if (top >= stickyTop) return;

            window.scrollTo({ top: Math.max(top + window.scrollY - stickyTop, 0) });
        });

        return () => cancelAnimationFrame(frameId);
    }, [results, toolbarRef]);

    return null;
};
